const exampleHTML = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Example Site</title>

</head>
<body>
  <h1>Welcome to Chetti.tools' Example HTML</h1>
  <p>Paste HTML and Javascript into the text box to the right</p>
  <ul> <li>
      <a href="https://avantlink.com" >a link to AvantLink.com </a>
  </li></ul>

  

  <h2>Why This Site Exists</h2>
  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
</body>
</html>

`;

export default exampleHTML;
